module.exports = __webpack_public_path__ + "static/media/shape2_5.e74979ae.obj";